import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import layoutContent from './content/content.vue'
import layoutHeader from './header/header.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "fd-wrap" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "fd-header" }, {
        default: _withCtx(() => [
          _createVNode(layoutHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "fd-main" }, {
        default: _withCtx(() => [
          _createVNode(layoutContent)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})